/**
 * Created by USER on 2018/11/1.
 */
export const GET_BANNER= 'GET_BANNER';
export const GET_PARTNER = 'GET_PARTNER';

export function getBanner(data) {
  return {
    type: GET_BANNER,
    data
  };
}

export function getPartner(data) {
  return {
    type: GET_PARTNER,
    data
  };
}
